import angular from 'angular';

(function() {
    'use strict';
    var core = angular.module('app.core');

    var DEFAULT_CELL_TEMPLATE =
        '<a class="grid-cell-link" ui-sref="app.docrepoinvoice.detail_tabs({ guid: row.entity.id, invoice: row.entity })"><div class="ui-grid-cell-contents">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';

    core.constant(
        'INVOICE',
        Object.freeze({
            status: {
                toBeFixed: { id: 'to_be_fixed' },
                buyerCheck: { id: 'buyer_check' },
                notCompliant: { id: 'not_compliant' },
                notCompliantManaged: { id: 'not_compliant_managed' },
                compliant: { id: 'compliant' },
                archived: { id: 'archived' },
                processed: { id: 'processed' },
                sent: { id: 'sent' },
                received: { id: 'received' },
                integrated: { id: 'integrated' },
                notApproved: { id: 'not_approved' },
                notMatched: { id: 'not_matched' },
                litigation: { id: 'litigation' },
                blocked: { id: 'blocked' },
                goodToPay: { id: 'good_to_pay' },
                paid: { id: 'paid' },
                created: { id: 'created' },
                proposedForSender: { id: 'proposed_for_sender' },
                validated: { id: 'validated' }
            },
            pagination: {
                defaultPageSize: 20,
                defaultSort: [
                    {
                        direction: 'DESC',
                        property: 'updatedDate',
                        priority: 1
                    }
                ]
            },
            columnDefs: [
                {
                    name: 'sellerName',
                    displayName: 'commons.seller',
                    headerCellFilter: 'translate',
                    cellClass: 'pointer',
                    width: 340,
                    cellTemplate: DEFAULT_CELL_TEMPLATE
                },
                {
                    name: 'displayLabelAndPerimeter()',
                    displayName: 'commons.company',
                    headerCellFilter: 'translate',
                    cellClass: 'pointer',
                    width: 340,
                    cellTemplate: DEFAULT_CELL_TEMPLATE
                },
                {
                    name: 'getTypeLabel()',
                    displayName: 'commons.type',
                    headerCellFilter: 'translate',
                    cellClass: 'pointer',
                    width: 130,
                    cellTemplate: DEFAULT_CELL_TEMPLATE
                },
                {
                    name: 'creationDate',
                    displayName: 'commons.creationDate',
                    headerCellFilter: 'translate',
                    cellClass: 'pointer',
                    width: 160,
                    cellFilter: "date:'short'",
                    cellTemplate: DEFAULT_CELL_TEMPLATE
                },
                {
                    name: 'getStatusLabel()',
                    displayName: 'commons.status',
                    headerCellFilter: 'translate',
                    cellClass: 'pointer',
                    width: 100,
                    enableSorting: false,
                    cellTemplate: DEFAULT_CELL_TEMPLATE
                },
                {
                    name: 'invoiceNumber',
                    displayName: 'kiss_order.invoice_num',
                    headerCellFilter: 'translate',
                    cellClass: 'pointer',
                    width: 220,
                    cellTemplate: DEFAULT_CELL_TEMPLATE
                },
                {
                    name: 'getCommandOrContractRef()',
                    displayName: 'kiss_order.num_order',
                    headerCellFilter: 'translate',
                    cellClass: 'pointer',
                    width: 220,
                    cellTemplate: DEFAULT_CELL_TEMPLATE
                },
                {
                    name: 'id',
                    displayName: 'kiss_order.list.guid',
                    headerCellFilter: 'translate',
                    cellClass: 'pointer',
                    width: '**',
                    enableSorting: false,
                    cellTemplate: DEFAULT_CELL_TEMPLATE
                }
            ]
        })
    );
})();
